import { IRegisterAccountRequest, RegisterAccount } from '../contracts';
import LogCannon from '@ace-clublabs/log-cannon';
import axios, { AxiosResponse } from 'axios';
import { createAxiosConfig } from '../mockHelper';
import CookieHelper from '../../utils/cookieHelper';

export const RegisterAccountApi =
  (endpoint: string): RegisterAccount =>
  async ({ sessionId, email, password, partnerEnrollments }: IRegisterAccountRequest) => {
    try {
      const scenario = CookieHelper.getCookie('scenario');

      if (!password || !sessionId) {
        return Promise.resolve({ success: false });
      }

      const response = await axios.post(
        endpoint,
        { sessionId, email, password, partnerEnrollments },
        createAxiosConfig(scenario, endpoint)
      );
      LogCannon.blast('RegisterAccountApi success');
      return Promise.resolve(response?.data); // {success: true}
    } catch (e: any) {
      if (e.response) {
        const message = e?.response?.data?.error?.message;
        const error_code = e?.response?.data?.error?.error_code;
        return Promise.resolve({ success: false, message, error_code });
      }
      return Promise.resolve({ success: false });
    }
  };
